import Vue from 'vue'

import Modal from './components/elements/Modal.vue'
import Loader from './components/elements/Loader.vue'

const registerGlobalComponents = () => {
  Vue.component('Modal', Modal)
  Vue.component('Loader', Loader)
}

export default registerGlobalComponents
